import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgMinusIcon = function SvgMinusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#828282",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.08 10.455a1.07 1.07 0 0 1 1.072 1.067v1.098c0 .59-.483 1.067-1.073 1.067H5.063A1.07 1.07 0 0 1 3.99 12.62v-1.098c0-.59.483-1.067 1.073-1.067z"
  })));
};

export { SvgMinusIcon as default };
